import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = ["innerHTML"]

import { ref, onMounted } from 'vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'footerText',
  props: {
    itemData: {}
  },
  setup(__props: any) {

const footerHtmlText = ref('')
const props = __props
onMounted(() => {
    footerHtmlText.value = props.itemData.htmlText
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", { innerHTML: footerHtmlText.value }, null, 8, _hoisted_3)
    ])
  ]))
}
}

})